const initialState = {
    name: "alex"
}

export default function menuReducer(state = initialState, action) {
    // console.log(state.name)
    return state;
}